import React from 'react';

// Landing page for the SignNow new-tab signing flow. The `/intake-complete`
// route is registered in BOTH the authenticated and unauthenticated Switch
// branches in App/index.js by design, so this page renders regardless of
// whether the new tab inherited a session or not. It must therefore stay free
// of any Redux connect and authenticated API calls. The original intake tab
// handles actual progression via onboarding polling.

const HEADING = 'Your intake has been signed.';
const BODY =
	"You can close this tab and return to your intake window — you'll be taken to your dashboard automatically.";

const containerStyle = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	minHeight: '100vh',
	padding: '1.5rem',
	textAlign: 'center',
};

const cardStyle = {
	maxWidth: '32rem',
};

export default function IntakeComplete() {
	return (
		<div style={containerStyle}>
			<div style={cardStyle}>
				<h1>{HEADING}</h1>
				<p>{BODY}</p>
			</div>
		</div>
	);
}
